export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48')
];

export const server_loads = [];

export const dictionary = {
		"/(app)": [9,[2]],
		"/(app)/admin": [10,[2,3]],
		"/(app)/admin/evaluations": [11,[2,3]],
		"/(app)/admin/functions": [12,[2,3]],
		"/(app)/admin/functions/create": [13,[2,3]],
		"/(app)/admin/functions/edit": [14,[2,3]],
		"/(app)/admin/settings": [15,[2,3]],
		"/(app)/admin/users": [16,[2,3]],
		"/api-pricing": [38],
		"/auth": [39],
		"/(app)/channels/[id]": [18,[2]],
		"/chatgpt-alternative": [40,[8]],
		"/(app)/c/[id]": [17,[2]],
		"/error": [41],
		"/(app)/home": [19,[2,4]],
		"/h": [42],
		"/legal/privacy": [43],
		"/legal/refund": [44],
		"/memtree-api": [45],
		"/(app)/notes": [20,[2,5]],
		"/(app)/notes/[id]": [21,[2,5]],
		"/(app)/playground": [22,[2,6]],
		"/(app)/playground/completions": [23,[2,6]],
		"/pricing": [46],
		"/s/[id]": [47],
		"/watch": [48],
		"/(app)/workspace": [24,[2,7]],
		"/(app)/workspace/functions/create": [25,[2,7]],
		"/(app)/workspace/knowledge": [26,[2,7]],
		"/(app)/workspace/knowledge/create": [28,[2,7]],
		"/(app)/workspace/knowledge/[id]": [27,[2,7]],
		"/(app)/workspace/models": [29,[2,7]],
		"/(app)/workspace/models/create": [30,[2,7]],
		"/(app)/workspace/models/edit": [31,[2,7]],
		"/(app)/workspace/prompts": [32,[2,7]],
		"/(app)/workspace/prompts/create": [33,[2,7]],
		"/(app)/workspace/prompts/edit": [34,[2,7]],
		"/(app)/workspace/tools": [35,[2,7]],
		"/(app)/workspace/tools/create": [36,[2,7]],
		"/(app)/workspace/tools/edit": [37,[2,7]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.svelte';